import { render, staticRenderFns } from "./PurChaseRecivingDetails.vue?vue&type=template&id=214bd6f4&"
import script from "./PurChaseRecivingDetails.vue?vue&type=script&lang=js&"
export * from "./PurChaseRecivingDetails.vue?vue&type=script&lang=js&"
import style0 from "./PurChaseRecivingDetails.vue?vue&type=style&index=0&id=214bd6f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports